<div class="modal-header">
    <h4 class="modal-title" translate="HEADER_IMPROVE_ROUTE_EFFICIENCY"></h4>
    <button type="button" class="close" (click)="dismissModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

@if (suggestions$ | async; as improvementSuggestions) {
    <div class="modal-body">
        <div class="container-flex">
            <div class="info-text">
        <span
            [innerHTML]="
                        (uncheckedAny
                            ? 'TRAVEL_TIME_IMPROVEMENTS_INFO_2'
                            : timeWindowSmaller
                            ? 'TRAVEL_TIME_IMPROVEMENTS_INFO_3'
                            : 'TRAVEL_TIME_IMPROVEMENTS_INFO_1'
                        ) | translate: { value: improvementSuggestions.travelTimeSuggestion }
                    "
        ></span>
            </div>
            <app-table loadingTableText="LOADING_INFO_ANALYZING_ROUTE_IMPROVEMENTS" [loadingTable]="loading">
                <ng-container header>
                    <th class="flex-1" translate="TASK_ID"></th>
                    <th class="flex-3" translate="CLIENT"></th>
                    <th class="flex-3" translate="DESCRIPTION"></th>
                    <th class="flex-2" translate="CURRENT_TIME_WINDOW"></th>
                    <th class="flex-2" translate="PROPOSED_TIME_WINDOW"></th>
                    <th class="flex-1 justify-content-center" translate="PERMANENT"></th>
                    @if (improvementSuggestions.suggestions?.length > 1) {
                        <th
                            class="flex-1 justify-content-center"
                            translate="SELECT"
                        ></th>
                    }
                    <th class="flex-1"></th>
                </ng-container>
                <ng-container body>
                    @for (suggestion of improvementSuggestions.suggestions; track suggestion) {
                        @if (!suggestion.editing) {
                            <tr [ngClass]="{ 'deselected-row': !suggestion.checked }">
                                <td class="flex-1">
                                    <span>{{ suggestion.taskId }}</span>
                                </td>
                                <td class="flex-3">
                                    <span>{{ suggestion.patientName }}</span>
                                </td>
                                <td class="flex-3">
                                    <span [innerHTML]="suggestion.taskDescription"></span>
                                </td>
                                <td class="flex-2">
                                    {{ suggestion.originalStartTime }} - {{ suggestion.originalEndTime }}
                                </td>
                                <td class="flex-2">
                  <span
                      [ngClass]="{
                                        'proposed-time-changed':
                                            suggestion.proposedStartTime !== suggestion.originalProposedStartTime
                                    }"
                  >
                    {{ suggestion.proposedStartTime }}
                  </span>
                                    &nbsp;-&nbsp;
                                    <span
                                        [ngClass]="{
                                        'proposed-time-changed':
                                            suggestion.proposedEndTime !== suggestion.originalProposedEndTime
                                    }"
                                    >
                    {{ suggestion.proposedEndTime }}
                  </span>
                                </td>
                                <td class="flex-1 justify-content-center no-top-bottom-padding">
                  <span
                      [ngClass]="{
                                        'vismaicon vismaicon-sm vismaicon-no-hover vismaicon-filled vismaicon-success':
                                            suggestion.permanent,
                                        'icon-unchecked icon-unchecked-sm': !suggestion.permanent
                                    }"
                  ></span>
                                </td>
                                @if (improvementSuggestions.suggestions?.length > 1) {
                                    <td
                                        class="flex-1 justify-content-center"
                                    >
                                        <app-checkbox
                                            [id]="suggestion.taskId"
                                            [(ngModel)]="suggestion.checked"
                                            (change)="checkboxChanged(improvementSuggestions.suggestions, suggestion)"
                                        ></app-checkbox>
                                    </td>
                                }
                                <td class="flex-1 justify-content-center no-top-bottom-padding">
                  <span
                      class="vismaicon vismaicon-sm vismaicon-edit"
                      [ngClass]="{ disabled: editing || !suggestion.checked }"
                      (click)="edit(suggestion, $event)"
                  ></span>
                                </td>
                            </tr>
                        }
                        @if (suggestion.editing) {
                            <app-travel-time-improvement-suggestion-edit
                                [firstColumnVisible]="improvementSuggestions.suggestions?.length > 1"
                                [suggestion]="suggestion"
                                (editing)="editingChange($event, improvementSuggestions.suggestions)"
                            ></app-travel-time-improvement-suggestion-edit>
                        }
                    }
                </ng-container>
            </app-table>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" id="secondary" class="btn btn-secondary" [disabled]="loading" (click)="dismissModal()">
            {{ 'CANCEL' | translate }}
        </button>
        <div class="right-container">
            <button
                type="button"
                class="btn btn-default mr-2"
                translate="REJECT"
                (click)="rejectAll(improvementSuggestions.suggestions)"
            ></button>
            <button
                data-qa="qa-accept-button"
                type="button"
                class="btn btn-primary"
                translate="BUTTON_ACCEPT_SELECTED"
                [disabled]="uncheckedAll"
                (click)="accept(improvementSuggestions.suggestions)"
            ></button>
        </div>
    </div>
} @else {
    <div class="loading-container">
        <span class="spinner spinner-lg"></span>
        <span class="loading-text" translate="LOADING_INFO_ANALYZING_ROUTE_IMPROVEMENTS"></span>
    </div>
}

